<template lang="pug">
  v-layout(row, wrap)
    v-flex(xs12)
      v-menu(ref='startMenu', v-model='startMenu', :close-on-content-click='false', :nudge-right='40', :return-value.sync='startDateDisplay', lazy, transition='scale-transition' max-width='290' offset-y full-width)
        template(slot='activator')
          v-text-field(v-model='startDateDisplayNormal', :label="`${(range) ? 'Start Date' : (label) ? label : 'Date'}`", :prepend-icon="`${(showIcon) ? 'event' : ''}`", readonly, :clearable='clearable')
        v-date-picker(v-model='startDate' v-show='!start.selectTime', :max='endDate' v-if="!autoSubmit" @input="inputSubmit" )
        v-date-picker(v-model='startDate' v-show='!start.selectTime', :max='endDate' v-else )
          v-layout(row v-if="autoSubmit")
            v-spacer
            v-btn(flat, color='primary', @click='startMenu = false') Cancel
            v-btn(flat, color='primary', @click='start.selectTime = true', v-if='!hideTime') Select Time
            v-btn(flat, color='primary', @click='$refs.startMenu.save(startDateDisplay)', v-else) OK
        v-time-picker(v-model='start.time', v-if='start.selectTime')
          v-spacer
          v-btn(flat, color='primary', @click='startMenu = false;') Cancel
          v-btn(flat, color='primary', @click='$refs.startMenu.save(startDateDisplay) ', :disabled='!start.time') OK
    v-flex(xs12)
      v-menu(v-if='range && startDate', ref='endMenu', v-model='endMenu', :close-on-content-click='false', :nudge-right='40', :return-value.sync='endDateDisplay', lazy, transition='scale-transition' max-width='290' offset-y, full-width)
        template(slot='activator')
          v-text-field(v-model='endDateDisplayNormal', :label="`${(endlabel) ? endlabel : 'End Date'}`", :prepend-icon="`${(showEndIcon) ? 'event' : ''}`", readonly, :clearable='clearable')
        v-date-picker(v-model='endDate', v-show='!end.selectTime', :min='startDate', :max="(noFuture) ? $moment().format('YYYY-MM-DD') : null")
          v-spacer
          v-btn(flat, color='primary', @click='endMenu = false') Cancel
          v-btn(flat, color='primary', @click='end.selectTime = true', v-if='!hideTime') Select Time
          v-btn(flat, color='primary', @click='$refs.endMenu.save(endDateDisplay)', v-else) OK
        v-time-picker(v-model='end.time', v-if='end.selectTime')
          v-spacer
          v-btn(flat, color='primary', @click='endMenu = false; end.selectTime = false') Cancel
          v-btn(flat, color='primary', @click='$refs.endMenu.save(endDateDisplay)', :disabled='!end.time') OK

</template>
<script>
export default {
  name: 'date-time-picker',
  props: ['label', 'endlabel', 'range','hideTime', 'showIcon','showEndIcon', 'clearable', 'initStartDate', 'initEndDate', 'noFuture', 'autoSubmit'],
  created() {
    this.reset()
  },
  data() {
    return {
      startMenu: false,
      start:  {
        date: null,
        time: null,
        selectTime: false,
      },
      endMenu: false,
      end: {
        date: null,
        time: null,
        selectTime: false,
      }
    }
  },
  computed: {
    startDate: {
      get() {
        return (this.start.date) ? `${this.start.date.format('YYYY-MM-DD')}` : null
      },
      set(val) {
        if (!val) return this.start.date = null
        this.start.date = new this.$moment(val)

        if (this.start.time) {
          const time = this.start.time.split(":")
          this.start.date.set({ hour: time[0], minute: time[1] })
        }
      }
    },
    endDate: {
      get() {
        return (this.end.date) ? `${this.end.date.format('YYYY-MM-DD')} ` : null
      },
      set(val) {
        if (!val) return this.end.date = null
        this.end.date = new this.$moment(val)

        if (this.end.time) {
          const time = this.end.time.split(":")
          this.end.date.set({ hour: time[0], minute: time[1] })
        }
      }
    },
    startDateDisplay: {
      get() {
        return (this.start.date) ? `${this.start.date.format('MM/DD/YYYY')} ${(this.start.time) ? this.start.time : ''}` : null
      },
      set(val) {
        if (val) {
          const newDate = new Date(val).toISOString()
          this.startDate = this.$moment(newDate).format('YYYY-MM-DD')
          
        } else {
          this.startDate = null
          this.start.time = null
        }
        this.submit()
        
      }
    },
    endDateDisplay: {
      get() {
        return (this.end.date) ? `${this.end.date.format('MM/DD/YYYY')} ${(this.end.time) ? this.end.time : ''}` : null
      },
      set(val) {
        if (val) {
          const newDate = new Date(val).toISOString()
          this.endDate = this.$moment(newDate).format('YYYY-MM-DD')
          
        } else {
          this.endDate = null
          this.end.time = null
        }
        this.submit()
      }
    },
    startDateDisplayNormal: {
      get() {
        return (this.start.date) ? `${this.start.date.format('MM/DD/YYYY')} ${(this.start.time) ? this.$moment(`${this.start.date.format('YYYY-MM-DD')} ${this.start.time}`).format('hh:mm a') : ''}` : null
      },
      set() {
        this.start.time = null
        this.start.date = null
        return this.submit()
      }
    },
    endDateDisplayNormal: {
      get() {
        return (this.end.date) ? `${this.end.date.format('MM/DD/YYYY')} ${(this.end.time) ? this.$moment(`${this.end.date.format('YYYY-MM-DD')} ${this.end.time}`).format('hh:mm a') : ''}` : null
      },
      set() {
        this.end.time = null
        this.end.date = null
        return this.submit()
      }
    },
  },
  methods: {
    inputSubmit() {
      if(!this.hideTime) {
        this.start.selectTime = true
      } else {
        this.$refs.startMenu.save(this.startDateDisplay)
      }
    },
    reset() {
      if (this.initStartDate) {
        this.start.date = this.initStartDate
        this.start.time =  (!this.hideTime) ? this.$moment(this.initStartDate).format('HH:mm') : null
      }
      if (this.initEndDate) {
        this.end.date = this.initEndDate
        this.end.time =  (!this.hideTime) ? this.$moment(this.initStartDate).format('HH:mm') : null
      }
    },
    submit() {
      let date = null
      if (this.range) {
        date = {
          start: (this.start.date) ? (this.start.time) ? this.start.date.toISOString() : this.start.date.startOf('day').toISOString() : null,
          end: (this.end.date) ? (this.end.time) ? this.end.date.toISOString() : this.end.date.endOf('day').toISOString() : null,
        }
      } else { 
        if (this.start.date) date = (this.start.time) ? this.start.date.toISOString() : this.start.date.startOf('day').toISOString() 
      }
      this.start.selectTime = false
      this.end.selectTime = false
      if (date) this.$emit('input', date)
    }
  },
  watch: {
    startDateDisplayNormal(val) {
      if (val === null) {
        this.end.date = null
        this.end.time = null
      }
    }
  }
}
</script>

